"use client";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { uptimeMetrics as data } from "@/lib/data/status";

const accent = "var(--color-purple)";

export function UptimeMetrics() {
  return (
    <Section id="uptime-metrics" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <h3 className="text-lg mt-10 mb-3">Monthly Uptime History</h3>
          <div className="glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Month</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Uptime</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Downtime</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Incidents</th>
                  </tr>
                </thead>
                <tbody>
                  {data.monthly.map((m) => (
                    <tr key={m.month} className="border-b border-[rgb(var(--border)/0.08)]">
                      <td className="px-4 py-3 align-top font-medium">{m.month}</td>
                      <td className="px-4 py-3 align-top text-right font-mono text-xs" style={{ color: accent }}>{m.uptime}</td>
                      <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs">{m.downtime}</td>
                      <td className="px-4 py-3 align-top text-right hidden md:table-cell">{m.incidents}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
        <Reveal delay={200}>
          <h3 className="text-lg mt-8 mb-3">Annual Uptime Summary</h3>
          <div className="glass rounded-2xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[rgb(var(--border)/0.18)] bg-[rgb(var(--border)/0.04)]">
                    <th className="text-left px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Year</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))]">Uptime</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">Total Downtime</th>
                    <th className="text-right px-4 py-3 eyebrow-tiny text-[rgb(var(--fg-subtle))] hidden md:table-cell">SLA Met</th>
                  </tr>
                </thead>
                <tbody>
                  {data.annual.map((a) => (
                    <tr key={a.year} className="border-b border-[rgb(var(--border)/0.08)]">
                      <td className="px-4 py-3 align-top font-medium">{a.year}</td>
                      <td className="px-4 py-3 align-top text-right font-mono text-xs" style={{ color: accent }}>{a.uptime}</td>
                      <td className="px-4 py-3 align-top text-right hidden md:table-cell font-mono text-xs">{a.total}</td>
                      <td className="px-4 py-3 align-top text-right hidden md:table-cell text-[var(--color-emerald)] font-semibold">{a.sla}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>
        <div className="mt-8 grid lg:grid-cols-2 gap-5">
          <Reveal delay={300}>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>SLA Calculation</span>
              <pre className="mt-3 text-xs font-mono text-[rgb(var(--fg-muted))] whitespace-pre-wrap leading-relaxed">{data.calculation}</pre>
            </div>
          </Reveal>
          <Reveal delay={350}>
            <div className="glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Audit</span>
              <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.audit}</p>
            </div>
          </Reveal>
        </div>
      </Container>
    </Section>
  );
}
